import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import styled from 'styled-components';
import { motion } from 'framer-motion';

import { AboutModal, SettingsModal, DisconnectModal } from './index';
import AppContext from '../context/AppContext';

import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';

import SettingsIcon from '@mui/icons-material/Settings';
import NotificationsIcon from '@mui/icons-material/Notifications';

import DarkModeIcon from '@mui/icons-material/DarkMode';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import SearchIcon from '@mui/icons-material/Search';
import VideocamIcon from '@mui/icons-material/Videocam';

import logo from '../assets/images/logo.png';
import CloseIcon from '@mui/icons-material/Close';
const Nav = () => {
  const navigate = useNavigate();
  const [showSettings, setShowSettings] = useState(false);
  const [showDisconnect, setShowDisconnect] = useState(false);
  const [showAbout, setShowAbout] = useState(false);
  const {
    currentAccount,
    accountDetails,
    connectWallet,
    disconnectWeb3Modal,
    theme,
    changeTheme,
    sideNav,
    setSideNav,
  } = useContext(AppContext);

  const handlerThemeSwitch = () => {
    changeTheme();
  };

  return (
    <StyledNav theme_={theme} sideNav={sideNav}>
      <div className="main">
        <div className="nav">
          <Link className="item icon" to="/">
            {' '}
            <img src={logo} alt="img" /> <h2>SpeakOut</h2>{' '}
          </Link>
          <Link className="item" to="/">
            <HomeIcon /> <h2>Home</h2>
          </Link>
          <Link className="item" to="/shorts">
            <VideocamIcon /> <h2>Shorts</h2>
          </Link>
          <Link className="item" to="/notifications">
            <NotificationsIcon /> <h2>Notifications</h2>
          </Link>
          <Link to="/search" className="desk-hide">
            <SearchIcon />
          </Link>
          <Link className="item mob-hide" to={`/${accountDetails?.handle}`}>
            <PersonIcon /> <h2>Profile</h2>
          </Link>
          <Link className="item mob-hide" to="/settings">
            <SettingsIcon /> <h2>Settings</h2>
          </Link>
          {theme ? (
            <button
              onClick={() => changeTheme()}
              className="theme-btn mob-hide"
            >
              <DarkModeIcon />
            </button>
          ) : (
            <button
              onClick={() => changeTheme()}
              className="theme-btn mob-hide"
            >
              <Brightness7Icon />
            </button>
          )}
        </div>

        <SettingsModal
          show={showSettings}
          onClose={() => setShowSettings(false)}
          changeTheme={changeTheme}
        />
        <AboutModal
          show={showAbout}
          onClose={() => setShowAbout(false)}
          changeTheme={changeTheme}
        />
        <DisconnectModal
          show={showDisconnect}
          onClose={() => setShowDisconnect(false)}
          disconnect={disconnectWeb3Modal}
          account={currentAccount}
        />
      </div>
      <div className="sideNav">
        <button className="plain-btn cancel" onClick={() => setSideNav(false)}>
          <CloseIcon />
        </button>
        <Link className="item mob-hide" to={`/${accountDetails?.handle}`}>
          <PersonIcon />
        </Link>
        <Link className="item mob-hide" to="/settings">
          <SettingsIcon />
        </Link>

        {theme ? (
          <button onClick={() => changeTheme()} className="theme-btn mob-hide">
            <DarkModeIcon />
          </button>
        ) : (
          <button onClick={() => changeTheme()} className="theme-btn mob-hide">
            <Brightness7Icon />
          </button>
        )}
      </div>
    </StyledNav>
  );
};

const StyledNav = styled(motion.div)`
  .main {
    position: fixed;
    left: 0;
    top: 0;
    width: 20%;
    height: 100vh;
    -moz-box-shadow: 0 0 3px #ccc;
    -webkit-box-shadow: 0 0 3px #ccc;
    box-shadow: 0 0 3px #ccc;
    clip-path: inset(0px -15px 0px 0px);
    @media screen and (max-width: 900px) {
      width: 100%;
      height: auto;
      z-index: 2;
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(15, 15, 15,0.95)' : 'rgb(255, 255, 255,0.95)'};
      top: 92%;
      bottom: 0;
      left: 0;
    }

    .nav {
      display: flex;
      flex-flow: column wrap;
      justify-content: space-between;
      width: 100%;
      padding: 1rem 2rem;
      gap: 1.5rem;

      /* background: ${({ theme_ }) =>
        theme_ ? 'rgb(23, 24, 24,0.9)' : 'rgb(248, 248, 248,0.9)'}; */
      @media screen and (max-width: 900px) {
        flex-flow: row wrap;
        justify-content: space-between;
        align-items: center;
        height: 100%;
        padding-left: 0px;
        gap: 0rem;
        padding: 0rem 3.5rem;
        padding-left: 0rem;
      }
      .mob-hide {
        display: block;
        @media screen and (max-width: 900px) {
          display: none;
        }
      }
      .desk-hide {
        display: none;
        @media screen and (max-width: 900px) {
          display: block;
        }
      }
      .item {
        display: flex;
        flex-flow: row wrap;
        gap: 0.5rem;
        text-decoration: none;
        @media screen and (max-width: 1000px) {
          h2,
          img {
            display: none;
          }
        }
        @media screen and (max-width: 900px) {
          gap: 0rem;
          display: inline-block;
        }
        &.mob-hide {
          @media screen and (max-width: 900px) {
            display: none;
          }
        }
        &.icon {
          color: #50c1e9;
          display: flex;
          align-items: center;
          img {
            width: 2.5rem;
            color: #50c1e9;
          }
          @media screen and (max-width: 900px) {
            padding-bottom: 0rem;
          }
        }
        h2 {
          @media screen and (max-width: 900px) {
            display: none;
          }
        }
      }
      .theme-btn {
        width: 7rem;
      }
    }
    transition: 2s ease-in-out;
  }
  .sideNav {
    display: none;
    @media screen and (max-width: 900px) {
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(23, 24, 24,1)' : 'rgb(248, 248, 248,1)'};
      .cancel {
        margin-left: auto;
      }
      padding: 1rem 2rem;
      display: flex;
      flex-flow: column wrap;
      align-items: flex-start;
      gap: 1rem;

      position: fixed;
      top: 0%;
      left: 0;
      bottom: 0;
      width: 50%;
      height: 100vh;
      transform: ${({ sideNav }) =>
        sideNav ? 'translateX(0%)' : 'translateX(-100%)'};

      z-index: 4;
    }
  }
`;

export default Nav;
